/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Pauze_NieuwInputs */

const nl_planning_rooster_pauze_nieuw = /** @type {(inputs: Planning_Rooster_Pauze_NieuwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze`)
};

/**

* @param {Planning_Rooster_Pauze_NieuwInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_nieuw = /** @type {((inputs?: Planning_Rooster_Pauze_NieuwInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_NieuwInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_nieuw(inputs)
});
export { planning_rooster_pauze_nieuw as "planning.rooster.pauze.nieuw" }